import CrudActionContainer from './CrudActionContainer';
import NotesController from '../controllers/NotesController';
import commonHandler from '../errorHandlers/common-handler';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';

class NotesCRUDActions extends CrudActionContainer {
  addNoteAction: string;

  constructor() {
    super('NOTES');
    this.addNoteAction = super.makeActionKey('ADD_NOTE');
  }

  addNote(noteText: string, contactId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.addNoteAction));
      try {
        const response = await NotesController.addNote(noteText, contactId);
        dispatch(this.unbusy());
        return response.note;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }
}

const notesCRUDActions = new NotesCRUDActions();

export default notesCRUDActions;

export const useNotesCRUDActions = getActionHookBuilder(notesCRUDActions, [
  'addNote',
]);
